import React from 'react'
import styles from './RadioButton.module.scss'
import { getAllClassNames } from 'helpers'


type RadioButtonProps = {
    label?: string
    id?: string
    value: string
    isSelected?: boolean  
    className?: string 
    name?: string    
    ariaLabel?: string
    onSelecteRadio: (value: string) => void
    }
function RadioButton({label = '', id, value, isSelected, className, name, ariaLabel, onSelecteRadio}: RadioButtonProps) {
  return (
    <div className={getAllClassNames([label?.length === 0 ? styles.noLabel : '', styles.position])}>
        <input tabIndex={0} type="radio" name={name} id={id} checked={isSelected ? true : false} onChange={() => onSelecteRadio(value)} className={getAllClassNames([styles.radioInput])} aria-label={ariaLabel}/>
        {label && <label className={getAllClassNames([className, label.length ? styles.withLabel : ''])} htmlFor={id}>{label}</label>}
    </div>
  )
}

export default RadioButton